import React from 'react';

const ViewProposal = () => {
  return (
        <div className="container">
          <div className="row mt-4">
            <div className="col-md-3 text-center">
              <div className="proposal-html-logo">
                <a href="https://uae.wroffy.in/" className="d-block">
                  <img
                    src="https://uae.wroffy.in/uploads/company/9ea0214bd923fd9db9fb55f226ac7c85.png"
                    className="img-fluid"
                    alt="Wroffy - FZCO"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="row align-items-center pb-2">
            <div className="col-md-8 d-flex align-items-center">
              <h2 className="fw-bold me-2">#WFZ/24-25/PR/000018</h2>
              <span className="badge bg-warning">Expired</span>
            </div>
            <div className="col-md-4 text-end">
              <button className="btn btn-outline-primary ms-2">
                <i className="fa-regular fa-file-pdf"></i> Download
              </button>
            </div>
          </div>
        <div className="row mt-4">
          <div className="col-md-8">
            <div className="card p-3">
              <table className="table table-striped text-center">
                <thead>
                  <tr>
                    <th>#</th>
                    <th className="text-start">Item</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Tax</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td className="text-start">
                      <strong>Google Workspace Business Standard</strong>
                      <br /><span className="text-secondary">Annual Subscription</span>
                    </td>
                    <td>2</td>
                    <td>AED 634.00</td>
                    <td>0%</td>
                    <td>AED 1,268.00</td>
                  </tr>
                </tbody>
              </table>
              <div className="row text-end">
                <div className="col-md-6 offset-md-6">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td><strong>Sub Total</strong></td>
                        <td>AED 1,268.00</td>
                      </tr>
                      <tr>
                        <td><strong>Total</strong></td>
                        <td>AED 1,268.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card p-3">
              <h2 className="fw-bold">Proposal Information</h2>
              <p><b>Company:</b> Prime Hub Management Consultancy</p>
              <p><b>Location:</b> Dubai, AE</p>
              <p><b>Phone:</b> +971567196755</p>
              <p><b>Email:</b> <a href="mailto:support@company.com">support@company.com</a></p>
              <hr />
              <h4 className="fw-bold">Status:</h4>
              <span className="text-warning">Draft</span>
              <h4 className="fw-bold">Date:</h4>
              <p>21/09/2024</p>
              <h4 className="fw-bold">Open Till:</h4>
              <p>28/09/2024</p>
            </div>
          </div>
        </div>
    </div>
  );
};

export default ViewProposal;
